import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getStudentList = async (data) => {
  return decryptData(
    await axios.get(
      `/student?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// _________ get course list via user email __________
export const getCoursesViaStudentEmail = async (data) => {
  return decryptData(
    await axios.get(
      `/student/course/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getLectureViaStudentEmail = async (data) => {
  return decryptData(
    await axios.get(
      `/get-special-lecture-access-details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getLectureViaStudentEmailbyCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/get-special-lecture-access-details-by-course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getPersonalizedLectures = async (data) => {
  return decryptData(
    await axios.get(
      `/get-personalized-lecture-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getPersonalizedLectureListofCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/get-personalized-lecture-list-of-course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const deleteAssignedPersonalizedLecture = async (data) => {
  return decryptData(
    await axios.get(
      `/delete-personalized-lecture?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getCoursesViaStudentEmailForUpgradedCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/student/course/list/for/upgraded/courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getGPSCoursesStudentList = async (data) => {
  return decryptData(
    await axios.get(
      `/student/gps-course/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// _________ get course list via user email __________
export const gpsAccessPermission = async (data) => {
  return decryptData(
    await axios.get(
      `/student/course/gps/access?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// _____________  Get Courses by course type  ___________
export const getCourseListByType = async (data) => {
  return decryptData(
    await axios.get(
      `/student/course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// _____________  Get Student List by Course   ___________
export const getStudentListByCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/student/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getStudentListByCourseWithoutPagination = async (data) => {
  return decryptData(
    await axios.get(
      `/student/list/without/pagination?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// _____________  Get course list by student   ___________
export const getCoursesByStudent = async (data) => {
  return decryptData(
    await axios.get(
      `/student/free/access/course/list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// _____________  Get exp mobile course list by student   ___________
export const getExceptionalMobileCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/exceptional-mobile-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// _____________  bulk assign student to course    ___________
export const bulkAssignUserToCourse = async (data) => {
  return decryptData(await axios.post(`/student/bulk-assign`, data));
};


export const assignStudentExpMobileCourses = async (data) => {
  return decryptData(
    await axios.post(`/assign-student-expmobile-courses`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const deleteStudentExpMobileCourses = async (data) => {
  return decryptData(
    await axios.post(`/delete-student-expmobile-courses`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const deleteforallStudentExpMobileCourses = async (data) => {
  return decryptData(
    await axios.post(`/delete-for-all-student-expmobile-courses`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

// _____________  Add Course to user by admin   ___________
export const addFreeCourseAccess = async (data) => {
  return decryptData(
    await axios.get(
      `/student/grant/free/access/course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addSpecialLectureAccess = async (data) => {
  return decryptData(
    await axios.post(`/add-special-lectures`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const addPersonalizedLectureAccessByCourse = async (data) => {
  return decryptData(
    await axios.post(`/add-special-lectures-by-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

// _____________  Get student profile detail   ___________
export const getStudentProfileDetail = async (data) => {
  return decryptData(
    await axios.get(
      `/student/profile?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ***************************  Create Student Profile *********************************
export const addStudentUserDetails = async (data) => {
  return decryptData(await axios.post(`add-User`, data, setMultiPartHeader()));
};

// _____________  Update User Profile   ___________
export const updateUserProfile = async (data) => {
  return decryptData(
    await axios.post(`/student/update/profile`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

// _____________  Update User Documents   ___________
export const updateUserDocument = async (data, option) => {
  return decryptData(
    await axios.post(`/student/update/document`, data, option)
  );
};

export const getOldStudentList = async (data) => {
  return decryptData(
    await axios.get(
      `/old-student-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getOldStudentListbyEmailID = async (data) => {
  return decryptData(
    await axios.get(
      `/get-old-student-by-emailid?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addOldStudentDetails = async (data) => {
  return decryptData(
    await axios.post(`/add-old-student-details`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const verifyMobile = async (data) => {
  return decryptData(
    await axios.post(`/verify-mobile-number`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const adminInvoiceGeneration = async (data) => {
  return decryptData(
    await axios.post(`/invoice-generation`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const courseAccessReport = async (data) => {
  return decryptData(
    await axios.get(
      `/get-course-access-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getdetailsofstudentViaStudentEmailorphone = async (data) => {
  return decryptData(
    await axios.get(
      `/get-student-details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getCoursetestforStudents = async (data) => {
  return decryptData(
    await axios.get(
      `/get-course-test-for-students?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCourseforStudents = async (data) => {
  return decryptData(
    await axios.get(
      `/get-course-for-students?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getWatchingHoursforStudents = async (data) => {
  return decryptData(
    await axios.get(
      `/get-watching-hours-for-student?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// *********************************** Student Details ***********************************************
export const getStudentDetail = async (data) => {
  return decryptData(
    await axios.get(
      `/get-student-and-course-details?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// *********************************** Student Details in On Demand Courses ***********************************************
export const getStudentDetailsForOnDemandCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/getStudentDetailsForOnDemandCourses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateStudentOnDemandCourseEndDate = async (data) => {
  return decryptData(
    await axios.post(`/updateStudentOnDemandCourseEndDate`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const studentUpgradeCourseToStudent = async (data) => {
  return decryptData(
    await axios.post(`/student/upgrade/course/to/student`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const addIFHStudent = async (data) => {
  return decryptData(
    await axios.post(`/add-ifh-students`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const addIFHStudentViaFile = async (data) => {
  return decryptData(
    await axios.post(`/add-ifh-student-import-excel`, data, setMultiPartHeader())
  );
};
export const getInterviewStudents = async (data) => {
  return decryptData(
    await axios.get(
      `/interview-students?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addInterviewStudent = async (data) => {
  return decryptData(
    await axios.post(`/interview-student-create`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const updateInterviewStudent = async (data) => {
  return decryptData(
    await axios.post(`/interview-student-edit`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};


export const deleteinterviewStudent = async (data) => {
  return decryptData(
    await axios.get(
      `/interview-student-delete?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};


export const getSingleInterviewStudentbyId = async (data) => {
  return decryptData(
    await axios.get(
      `/interview-student-view?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getAllStudentList = async (data) => {
  return decryptData(
    await axios.get(
      `/student/all-student-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
